import useAuth from 'hooks/useAuth'
import React from 'react'
import { checkFeatureFlag } from 'types/feature-flag'
import EditTemplate from './EditTemplate'
import EditTemplateV2 from './EditTemplateV2'

const EditTemplateSwitch: React.FC = () => {
  const { profile, isLoading } = useAuth()

  const useV2 = checkFeatureFlag({ name: 'template_editor_v2', level: 'user' }, profile!, isLoading)

  return useV2 ? <EditTemplateV2 /> : <EditTemplate />
}

export default EditTemplateSwitch
